import { Link } from "react-router-dom";
import { channels } from "@/mocks/news";

const ACCENT_MAP: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function ChannelSection() {
  return (
    <section aria-label="内容频道" className="w-full bg-foreground-950">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-2xl">
          <p className="text-xs font-label text-accent-400 tracking-widest mb-2">CHANNELS</p>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-background-50">
            四个频道，一轮吃瓜
          </h2>
          <p className="mt-3 text-sm text-background-200/80 leading-relaxed">
            想快就看突发与插播，想全就看头条专递，想弄明白来龙去脉就去深度瓜情。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {channels.map((channel) => (
            <Link
              key={channel.slug}
              to={`/dispatch/${channel.slug}`}
              className="group flex flex-col rounded-lg border border-background-100/15 bg-background-50/[0.04] p-5 hover:bg-background-50/[0.08] hover:border-accent-400/40 transition-colors cursor-pointer"
            >
              <span
                className={`w-11 h-11 flex items-center justify-center rounded-md ${ACCENT_MAP[channel.accent]} mb-4`}
              >
                <i className={`${channel.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-background-50">{channel.name}</h3>
              <p className="mt-2 text-sm text-background-200/70 leading-relaxed flex-1">{channel.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1 text-xs font-label text-accent-400 group-hover:gap-2 transition-all">
                进入频道
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}